import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuctionService } from './auction.service';
import { catchError, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuctionResolver {
  constructor(private auctionService: AuctionService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot) {
    const id = +(route.paramMap.get('id') || 0);
    if (id) {
      return this.auctionService.fetchAuction(id).pipe(
        catchError((err) => 
          {
            // Redirect to 404 page if the item is not found in the database
            this.router.navigate(['/404page']);
            return throwError(() => err);
          }));
    } else {
      return this.auctionService.fetchAuctions();
    }
  }
}
